import { SlideContentAnalyzer } from '@src/slide/application/service/slide-rating-and-improve/slide-content-analyzer';
import React from 'react';
import classNames from 'classnames';
import i18n from '@i18next/i18n';
import Button from '@tencent/dui-mobile/lib/components/Button';
import DUILoading from '@tencent/dui-mobile/lib/components/Loading';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import {
    AnalyzerResultType,
} from '@src/slide/application/service/slide-rating-and-improve/slide-content-analyzer.interface';
import Style from './start.less';
import BlankSearch from './mobile-blank-search.svg';
import Check from './check.svg';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import {
    RatingResult,
    ResultMode,
} from '@src/slide/application/service/slide-rating-and-improve/view/mobile/result/rating-result';

/**
 * 组件优先展示的类型
 */
export enum StartViewEnterType {
    Guide,
    Result,
}

export interface IStartViewProps {
    enterType: StartViewEnterType,
    resultMode: ResultMode,
    hidden: boolean;
    analyzer: SlideContentAnalyzer;
    selectionService?: ISelectionService;
    handleToOptimize?: () => void;
}

interface IStartViewState {
    isConfirm: boolean;
}

export class StartView extends React.Component<IStartViewProps, IStartViewState> {
    public constructor(props: IStartViewProps) {
        super(props);
        this.state = {
            isConfirm: false,
        };
    }

    public render() {
        return (
            <div className={Style.rating}
                style={{ display: this.props.hidden ? 'none' : 'flex', width: '100%', height: '100%' }}
            >
                { !this.state.isConfirm && this.props.enterType === StartViewEnterType.Guide
                    ? this.renderGuide(this.props.resultMode) : this.renderResult() }
            </div>);
    }

    private renderGuide(mode: ResultMode) {
        if (mode === ResultMode.Preview) {
            return (
                <div className={Style['rating-content-wrapper']}>
                    <img style={{ width: '160px', height: '160px' }} src={BlankSearch}/>
                    <div className={Style['rating-text-wrapper']}>
                        <div className={classNames(Style['rating-text-row'])}>
                            <img className={Style['rating-text-img']} src={Check} />
                            <div className={Style['rating-name']} >{i18n.t('检测排版常见问题')}</div>
                        </div>
                        <div className={classNames(Style['rating-text-row'])}>
                            <img className={Style['rating-text-img']} src={Check} />
                            <div className={Style['rating-name']} >{i18n.t('检测排版对齐问题')}</div>
                        </div>
                        <div className={classNames(Style['rating-text-row'])}>
                            <img className={Style['rating-text-img']} src={Check} />
                            <div className={Style['rating-name']} >{i18n.t('检测色彩可视对比度')}</div>
                        </div>
                    </div>
                    <Button
                        type='primary' className={Style['rating-confirm']}
                        style={{ marginTop: '24px', marginBottom: '24px' }}
                        onClick={this.onConfirmClick}
                    >{i18n.t('立即检查')}</Button>
                </div>
            );
        }
        return <div className={Style['rating-content-wrapper']}
            style={{
                justifyContent: 'space-evenly',
                padding: '24px 0',
            }}
        >
            <div style={{ display: 'flex' }}>
                <img style={{ width: '120px', height: '120px' }} src={BlankSearch}/>
                <div className={Style['rating-text-wrapper']}>
                    <div className={classNames(Style['rating-text-row'])}>
                        <img className={Style['rating-text-img']} src={Check}/>
                        <div className={Style['rating-name']}>{i18n.t('检测排版常见问题')}</div>
                    </div>
                    <div className={classNames(Style['rating-text-row'])}>
                        <img className={Style['rating-text-img']} src={Check}/>
                        <div className={Style['rating-name']}>{i18n.t('检测排版对齐问题')}</div>
                    </div>
                    <div className={classNames(Style['rating-text-row'])}>
                        <img className={Style['rating-text-img']} src={Check}/>
                        <div className={Style['rating-name']}>{i18n.t('检测色彩可视对比度')}</div>
                    </div>
                </div>
            </div>
            <Button
                type='primary' className={Style['rating-confirm']}
                onClick={this.onConfirmClick}
            >{i18n.t('立即检查')}</Button>
        </div>;
    }

    private renderResult() {
        return (<RatingResult
            mode={this.props.resultMode}
            analyzer={this.props.analyzer}
            selectionService={this.props.selectionService}
            handleToOptimizeOnPreviewMode={this.props.handleToOptimize}
        >
        </RatingResult>);
    }

    private onConfirmClick = () => {
        const loading = DUILoading.show({ tip: i18n.t('正在进行分析...'), zIndex: 11001 });
        setTimeout(async () => {
            await this.props.analyzer.analysis();
            loading.close();
            this.setState({ isConfirm: true });
            const reportObj = this.getObjFromResult();
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.AUTO_BEAUTIFY,
                action: TDWActionType.BEAUTIFY_SUCCESS,
                ver5: this.props.analyzer.score,
                ver6: JSON.stringify(reportObj),
            });
        }, 0);
    };

    private getObjFromResult() {
        const result: any = {};
        const titleFontResult = this.props.analyzer.textAnalyzer.titleFontSizeResult.getShowResult().length;
        const subTitleFontResult = this.props.analyzer.textAnalyzer.subTitleFontSizeResult.getShowResult().length;
        const lineSpacingResult = this.props.analyzer.textAnalyzer.lineSpacingResult.resultInfo.length;
        // const fontNumResult = this.props.analyzer.textAnalyzer.fontUseNumberResult.resultInfo;
        const textOverlapResult = this.props.analyzer.textAnalyzer.textOverlapResult.resultInfo.length;
        const contrastResult = this.props.analyzer.colorAnalyzer.textColorContrastResult.getShowResult().length;
        const titleAlignResult = this.props.analyzer.titleAlignmentResult.resultType;
        if (titleFontResult > 0) result.titleFont = titleFontResult;
        if (subTitleFontResult > 0) result.subTitleFont = subTitleFontResult;
        if (lineSpacingResult > 0) result.lineSpacing = lineSpacingResult;
        // if (fontNumResult > 0) result.fontNum = fontNumResult;
        if (textOverlapResult > 0) result.textOverlap = textOverlapResult;
        if (contrastResult > 0) result.contrast = contrastResult;
        if (titleAlignResult === AnalyzerResultType.ERROR) {
            result.titleAlign = 1;
        }
        return result;
    }
}
